var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('money',_vm._b({staticClass:"form-control",model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}},'money',_vm.money,false)),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.name,"required":_vm.required},domProps:{"value":_vm.price}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }